import React from "react"
import { Navigate, useParams } from "react-router-dom"

import { useRecoilValue } from "recoil"
import { ROUTES } from "src/App"

import { userState } from "@fuse/recoil/signup"

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { eventId } = useParams<{ eventId: string }>()

  const user = useRecoilValue(userState)

  const hasVisitedEventsPage = () =>
    localStorage.getItem("hasVisitedEventsPage") === eventId

  return hasVisitedEventsPage() && user.displayName ? (
    <>{children}</>
  ) : (
    <Navigate
      to={
        eventId
          ? `${ROUTES.EVENTS.replace(":eventId", eventId)}`
          : ROUTES.LANDING
      }
    />
  )
}

export default ProtectedRoute
